import { GlobalContext } from '../../../../../../../utils/globalprovider';

import React from 'react';

import './context-menu.css';
import { isEqual } from 'lodash';

class ContextMenu extends React.Component {
  static contextType = GlobalContext;

  Item(word, suggest, remplacement, index) {
    return (
      <div
        className="list-item"
        role="listitem"
        key={index}
        tabIndex={0}
        onClick={() =>
          this.props.onApplyCorrection(word, suggest, remplacement)
        }
      >
        <p>{remplacement}</p>
        <p className="message">{suggest.message}</p>
      </div>
    );
  }

  render() {
    if (!this.props.contextMenu.display) {
      return <></>;
    }

    const word = this.props.contextMenu.word;
    const suggest = word.suggest;

    if (!suggest) {
      return <></>;
    }

    const lang = this.context.language;

    const sameSuggests =
      this.props.subtitles
        .flatMap((subtitle) => subtitle.lines)
        .flatMap((line) =>
          line.words.filter(
            (x) =>
              x.suggest &&
              x.suggest.suggests.length === 1 &&
              isEqual(x.suggest.suggests, suggest.suggests)
          )
        ) || [];

    return (
      <div
        id="contextMenu"
        className="context-menu"
        style={{
          left: `${this.props.contextMenu.x}px`,
          top: `${this.props.contextMenu.y}px`,
        }}
      >
        <div role="list" className="list">
          {suggest.suggests.map((remplacement, index) => {
            return this.Item(word, suggest, remplacement, index);
          })}
        </div>
        <hr />
        <div role="list" className="list">
          <div
            className={'list-item' + (sameSuggests.length <= 1 ? ' hide' : '')}
            role="listitem"
            tabIndex={0}
            onClick={() => this.props.onApplyCorrectionAll(sameSuggests)}
          >
            {lang === 'fr'
              ? `Appliquer cette correction aux ${sameSuggests.length} occurences`
              : `Apply this correction to the ${sameSuggests.length} occurrences`}
          </div>
          <div
            className="list-item"
            role="listitem"
            tabIndex={0}
            onClick={() => this.props.onAddWordToDictionary(word)}
          >
            {lang === 'fr' ? 'Ajouter au dictionnaire' : 'Add to dictionary'}
          </div>
          <div
            className="list-item"
            role="listitem"
            tabIndex={0}
            onClick={() => this.props.onIgnoreWordForCorrection(word)}
          >
            {lang === 'fr' ? 'Ignorer ce mot' : 'Ignore this word'}
          </div>
          <div
            className="list-item"
            role="listitem"
            tabIndex={0}
            onClick={() => this.props.onIgnoreSuggestForCorrection(word)}
          >
            {lang === 'fr'
              ? 'Ignorer cette suggestion'
              : 'Ignore this suggestion'}
          </div>
        </div>
      </div>
    );
  }
}

export default ContextMenu;
